import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

const useStyles = makeStyles(() => ({
	card: {
		border: `1px solid ${colors.gray[200]}`,
		borderRadius: 10,
		padding: 16,
		display: "flex",
		flexDirection: "column",
		gap: 12
	},
	cardHeader: {
		display: "flex",
		alignItems: "center",
		gap: 11
	},
	fieldIconWrapper: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		flexShrink: 0,
		position: "relative",
		top: 1
	},
	fieldIcon: {
		fontSize: 24,
		color: colors.purple[500]
	},
	fieldName: {
		margin: 0,
		fontSize: 15,
		fontWeight: 700,
		color: colors.gray[800]
	},
	removeButton: {
		width: 30,
		height: 30,
		borderRadius: 7,
		backgroundColor: colors.red[100],
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		cursor: "pointer",
		flexShrink: 0,
		"&:hover": {
			backgroundColor: colors.red[200]
		}
	},
	removeIcon: {
		fontSize: 16,
		color: colors.red[600]
	},
	instructionBlock: {
		display: "flex",
		flexDirection: "column",
		gap: 6
	},
	instructionLabel: {
		fontSize: "12.5px",
		fontWeight: 700,
		color: colors.gray[700]
	},
	instructionField: {
		"& .MuiOutlinedInput-root": {
			borderRadius: 8,
			fontSize: 14,
			padding: "11px 12px",
			"& fieldset": {
				border: `1px solid ${colors.gray[200]}`
			},
			"&.Mui-focused fieldset": {
				border: `1px solid ${colors.purple[500]}`
			}
		}
	},
	conflictRow: {
		display: "flex",
		flexDirection: "column",
		gap: 6
	},
	conflictLabel: {
		fontSize: "12.5px",
		fontWeight: 700,
		color: colors.gray[700]
	},
	conflictSelect: {
		"& .MuiOutlinedInput-root": {
			borderRadius: 8,
			fontSize: 14,
			padding: "10px 12px",
			"& fieldset": {
				border: `1px solid ${colors.gray[200]}`
			}
		}
	}
}))

export default useStyles
